import { render, staticRenderFns } from "./AssessmentModeCard.vue?vue&type=template&id=2f6d6aab"
import script from "./AssessmentModeCard.vue?vue&type=script&lang=ts"
export * from "./AssessmentModeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports